import { Badge } from '@mui/material'
import React, { useEffect, useState } from 'react'
import api from '../../services/api';

export default function CountReclamacoes() {
    const [areaCount, setAreaCount] = useState([])


    useEffect(() => {

        api.get(`/reclamacoes?status=Análise`)
            .then(response => {
                setAreaCount(response.data?.totalItems);
            }).catch(error => {

            }).finally(() => '')

    }, [])
    return (
        <Badge
            // color={color}
            badgeContent={areaCount}
            max={999}
            invisible={areaCount === 0}
            sx={{
                '& .MuiBadge-badge': {
                    right: -3,
                    top: 5,
                    padding: '0 4px',
                    backgroundColor: 'var(--color-primary-500, #f97316)',
                    color: 'white',
                    fontWeight: 'bold',
                },
            }}
        >
            <img src={'/icones/Reclamacoes2.svg'} width={35} alt="icon" />
        </Badge>
    )
}
